import React from 'react';
import './button.css';
export function Button(props) {
    return (
        <div class="wrapper mt-4">
            <a className="button" onClick = {()=>props.click()}>{props.title}</a>
        </div>
    )
}